/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-env jquery */

import { Component, registerComponent } from 'js/component.js';

const componentName = 'repair-request-form';
class RepairRequestForm extends Component {
    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
        form: this.element.querySelector(`.${componentName}__form`),
        emailInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="email"]`),
        companyInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="company"]`),
        firstNameInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="firstName"]`),
        lastNameInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="lastName"]`),
        catalogNumberInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="catalogNumber"]`),
        serialNumberInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="serialNumber"]`),
        termsCheckbox: this.element.querySelector(`.${componentName}__terms-checkbox-container input`),
        termsTextContainer: this.element.querySelector(`.${componentName}__terms-text`),
        fileInput: this.element.querySelector(`.${componentName}__insurance-upload-input`),
        fileNameTextContainer: this.element.querySelector(`.${componentName}__insurance-upload-file-name-text-container`),
        fileNameText: this.element.querySelector(`.${componentName}__insurance-upload-file-name-text`),
        fileSelectedText: this.element.querySelector(`.${componentName}__insurance-upload-file-selected-text`),
        fileSizeExceededText: this.element.querySelector(`.${componentName}__insurance-upload-size-exceeded-text`),
        textInputs: this.element.querySelectorAll(`.${componentName}__text-inputs .ra-input__input`),
        submitButton: this.element.querySelector(`.${componentName}__submit-button`),
        successMessageContainer: this.element.querySelector(`.${componentName}__success-message-container`),
        signedOutContainer: this.element.querySelector(`.${componentName}__signed-out-container`),
        signInLink: this.element.querySelector(`.${componentName}__signed-out-button`),
    };

    constants = {
        theme: this.elements.container.dataset.theme,
        catalogNumber: this.elements.container.dataset.catalogNumber,
        servletPath: '/bin/right-to-repair'
    };

    handleValidation = (showErrorState = true) => {
        let hasError = false;
        const requiredFields = this.element.querySelectorAll('input[data-required], textarea[data-required], select[data-required]');

        [...requiredFields].forEach((fieldEle) => {
            if (fieldEle.disabled || fieldEle.closest(`.${this.constants.theme}-formfield`).classList.contains('hidden')) {
                return;
            }
            const isText = fieldEle.classList.contains(`${this.constants.theme}-input__input`);
            const isCheckbox = fieldEle.classList.contains(`${this.constants.theme}-checkbox__checkbox`);
            const isSelect = fieldEle.classList.contains(`${this.constants.theme}-select__select`);

            // Text Fields
            if (isText) {
                const inputValue = fieldEle.value;
                const isEmpty = inputValue === '';
                const parentContainerEle = fieldEle.closest(`.${this.constants.theme}-formfield`);
                const errorMessage = parentContainerEle.querySelector(`.${this.constants.theme}-formfield__caption-error`);

                if (isEmpty) {
                    hasError = true;
                    if (showErrorState) {
                        parentContainerEle.classList.add(`${this.constants.theme}-formfield--invalid`);
                        fieldEle.classList.add(`${this.constants.theme}-input__input--invalid`);
                        if (errorMessage) {
                            errorMessage.setAttribute('aria-hidden', 'false');
                        }
                    }
                } else {
                    parentContainerEle.classList.remove(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.remove(`${this.constants.theme}-input__input--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'true');
                    }
                }
            }

            // Checkboxes
            if (isCheckbox) {
                const parentContainerEle = fieldEle.closest(`.${this.constants.theme}-formfield`);
                const errorMessage = parentContainerEle.querySelector(`.${this.constants.theme}-formfield__caption-error`);
                let isEmpty = true;

                [...inputEles].forEach((inputEle) => {
                    if (inputEle.checked === true) {
                        isEmpty = false;
                    }
                });

                if (isEmpty) {
                    hasError = true;
                    if (showErrorState) {
                        parentContainerEle.classList.add(`${this.constants.theme}-formfield--invalid`);
                        fieldEle.classList.add(`${this.constants.theme}-checkbox__checkbox--invalid`);
                        if (errorMessage) {
                            errorMessage.setAttribute('aria-hidden', 'false');
                        }
                    }
                } else {
                    parentContainerEle.classList.remove(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.remove(`${this.constants.theme}-checkbox__checkbox--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'true');
                    }
                }
            }

            // Selects
            if (isSelect) {
                const isEmpty = fieldEle.value === '';
                const parentContainerEle = fieldEle.closest(`.${this.constants.theme}-formfield`);
                const errorMessage = parentContainerEle.querySelector(`.${this.constants.theme}-formfield__caption-error`);

                if (isEmpty) {
                    hasError = true;
                    if (showErrorState) {
                        parentContainerEle.classList.add(`${this.constants.theme}-formfield--invalid`);
                        fieldEle.classList.add(`${this.constants.theme}-select__select--invalid`);
                        if (errorMessage) {
                            errorMessage.setAttribute('aria-hidden', 'false');
                        }
                    }
                } else {
                    parentContainerEle.classList.remove(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.remove(`${this.constants.theme}-select__select--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'true');
                    }
                }
            }
        });

        return hasError;
    };

    handleFileInputChange = (event) => {
        const file = event.target.files[0];
        if (!file) {
            this.elements.fileNameText.textContent = '';
            this.elements.fileNameTextContainer.classList.add('empty');
            this.elements.fileSelectedText.classList.add('empty');
            this.elements.submitButton.disabled = !this.elements.termsCheckbox.checked || !event.target.value || this.handleValidation(false);
            return;
        }
        if (file.size > 5 * 1024 * 1024) {
            this.elements.fileNameText.textContent = '';
            this.elements.fileNameTextContainer.classList.add('empty');
            this.elements.fileSelectedText.classList.add('empty');
            this.elements.fileSizeExceededText.classList.remove('hidden');
            this.elements.submitButton.disabled = true;
            event.target.value = '';
            return;
        }
        this.elements.fileNameText.textContent = file.name;
        this.elements.fileNameTextContainer.classList.remove('empty');
        this.elements.fileSelectedText.classList.remove('empty');
        this.elements.fileSizeExceededText.classList.add('hidden');
        this.elements.submitButton.disabled = !this.elements.termsCheckbox.checked || !event.target.value;
    };

    handleFileNameRemove = () => {
        this.elements.fileInput.value = '';
        this.elements.fileNameText.textContent = '';
        this.elements.fileNameTextContainer.classList.add('empty');
        this.elements.fileSelectedText.classList.add('empty');
        this.elements.submitButton.disabled = true;
    };

    handleTermsCheckboxChange = () => {
        this.elements.submitButton.disabled = !this.elements.termsCheckbox.checked || !this.elements.fileInput.value || this.handleValidation(false);
    };

    handleSubmit = async (event) => {
        event.preventDefault();

        const hasError = this.handleValidation();
        if (hasError) {
            return;
        }

        const formData = new FormData(this.elements.form);
        const url = `${this.constants.servletPath}`;
        const response = await fetch(url, {
            method: 'POST',
            body: formData,
        });
        const data = await response.text();
        console.log('data', data);

        this.elements.successMessageContainer.classList.remove('hidden');
        this.elements.form.classList.add('hidden');
    };

    handleTermsTextContainerScroll = () => {
        if (!this.elements.termsCheckbox || !this.elements.termsCheckbox.disabled) {
            this.elements.termsTextContainer.removeEventListener('scroll', this.handleTermsTextContainerScroll);
            return;
        }
        const scrollPosition = this.elements.termsTextContainer.scrollTop;
        const containerHeight = this.elements.termsTextContainer.clientHeight;
        const contentHeight = this.elements.termsTextContainer.scrollHeight;
        const isAtBottom = scrollPosition + containerHeight >= contentHeight;
        this.elements.termsCheckbox.disabled = !isAtBottom;
    };

    handleTextInputChange = () => {
        this.elements.submitButton.disabled = !this.elements.termsCheckbox.checked || !this.elements.fileInput.value || this.handleValidation(false);
    };

    checkSignInStatus = () => {
        const queryParams = new URLSearchParams(window.location.search);
        let loggedInData;
        if (window['userData']) {
            loggedInData = window['userData'];
        } else if (localStorage.getItem('loggedInData')) {
            try {
                loggedInData = JSON.parse(localStorage.getItem('loggedInData'));
            } catch (e) {
                console.warn('Error parsing loggedInData from localStorage', e);
            }
        }
        if (loggedInData) {
            this.elements.emailInput.value = loggedInData.email;
            this.elements.companyInput.value = loggedInData.company;
            this.elements.firstNameInput.value = loggedInData.firstName;
            this.elements.lastNameInput.value = loggedInData.lastName;
            this.elements.serialNumberInput.value = queryParams.get('SN') || '';
            if (this.constants.catalogNumber) {
                this.elements.catalogNumberInput.value = this.constants.catalogNumber;
                this.elements.catalogNumberInput.disabled = true;
                this.elements.catalogNumberInput.classList.add(`${this.constants.theme}-input__input--disabled`);
            } else if (document.referrer.includes('/products/details.')) {
                const catalogNumber = document.referrer.split('/products/details.')[1].split('.')[0];
                this.elements.catalogNumberInput.value = catalogNumber;
            } else if (queryParams.get('catalogNumber')) {
                this.elements.catalogNumberInput.value = queryParams.get('catalogNumber');
            }
            this.elements.form.classList.remove('hidden');
        } else {
            this.elements.signedOutContainer.classList.remove('hidden');
            this.elements.signInLink.addEventListener('click', () => {
                if (document.querySelector('.account-menu__sign-in')) {
                    document.querySelector('.account-menu__sign-in').click();
                } else {
                    if (localStorage.getItem('adfsLogin')) {
                        window.location.href = localStorage.getItem('adfsLogin');
                    }
                }
            });
        }
    };

    addEventListeners = () => {
        this.elements.form.addEventListener('submit', async (event) => {
            window.dispatchEvent(new CustomEvent('show-loading'));
            await this.handleSubmit(event);
            window.dispatchEvent(new CustomEvent('hide-loading'));
        });
        this.elements.fileInput.addEventListener('change', this.handleFileInputChange);
        this.elements.termsTextContainer.addEventListener('scroll', this.handleTermsTextContainerScroll);
        this.elements.termsCheckbox.addEventListener('change', this.handleTermsCheckboxChange);
        this.elements.fileNameTextContainer.addEventListener('click', this.handleFileNameRemove);
        this.elements.textInputs.forEach((input) => {
            input.addEventListener('change', this.handleTextInputChange);
        });
    };

    initDom = () => { 
        this.elements.termsCheckbox.disabled = true;
        this.checkSignInStatus();
    };

    /**
     * Initialize Component
     */
    init = () => {
        this.initDom();
        this.addEventListeners();
    };
}

registerComponent(`.${componentName}`, RepairRequestForm);
